export default "__VITE_ASSET__BqGAp5Sf__"